import React from "react";
import "../Common/cmnStyle.css";

const PrivacyPolicy = () => {
  return (
    <div className="cmnTermsPage">
      <div className="cmnTermsDiv">
        <h1>Privacy Policy</h1>
        <div style={{ padding: "0 20px" }}>
          <div className="cmnTermsContent">
            <h5 style={{ color: "#333" }}>Privacy Policy for the website:</h5>
            <p>Updated 27th August 2016</p>
            <p>
              {"   "}
              This privacy policy has been compiled to better serve those who
              are concerned with how their 'Personally Identifiable Information'
              (PII) is being used online. PII, as described in Indian and
              International privacy law and information security, is information
              that can be used on its own or with other information to identify,
              contact, or locate a single person, or to identify an individual
              in context. Please read our privacy policy carefully to get a
              clear understanding of how we collect, use, protect or otherwise
              handle your Personally Identifiable Information in accordance with
              our website.
            </p>
            <p>
              What personal information do we collect from the people that visit
              our blog, website or app? <br />
              When ordering or registering on our site, as appropriate, you may
              be asked to enter your name, email address, phone number or other
              details to help you with your experience.
            </p>
            <p>
              When do we collect information? <br />
              We collect information from you when you register on our site,
              subscribe to a newsletter, respond to a survey, fill out a form,
              Use Live Chat, Open a Support Ticket, enter information on our
              site or provide us with feedback on our products or services.
            </p>
            <p>
              How do we use your information? <br />
              We may use the information we collect from you when you register,
              make a purchase, sign up for our newsletter, respond to a survey
              or marketing communication, surf the website, or use certain other
              site features in the following ways:
              <br />• To personalise your experience and to allow us to deliver
              the type of content and product offerings in which you are most
              interested.
              <br />• To improve our website in order to better serve you.{" "}
              <br />• To allow us to better service you in responding to your
              customer service requests.
              <br />• To administer a contest, promotion, survey or other site
              feature.
              <br />• To quickly process your transactions.
              <br />• To ask for ratings and reviews of services or products.
              <br />• To follow up with them after correspondence (live chat,
              email or phone inquiries)
            </p>
            <p>
              How do we protect your information? <br />
              We do not use vulnerability scanning and/or scanning to PCI
              standards. We only provide articles and information. We never ask
              for credit card numbers. We use regular Malware Scanning. Your
              personal information is contained behind secured networks and is
              only accessible by a limited number of persons who have special
              access rights to such systems, and are required to keep the
              information confidential. In addition, all sensitive/credit
              information you supply is encrypted via Secure Socket Layer (SSL)
              technology. We implement a variety of security measures when a
              user places an order enters, submits, or accesses their
              information to maintain the safety of your personal information.
              All transactions are processed through a gateway provider and are
              not stored or processed on our servers.
            </p>
            <p>
              Do we use 'cookies'? <br />
              Yes. Cookies are small files that a site or its service provider
              transfers to your computer's hard drive through your Web browser
              (if you allow) that enables the site's or service provider's
              systems to recognise your browser and capture and remember certain
              information. For instance, we use cookies to help us remember and
              process the items in your shopping cart. They are also used to
              help us understand your preferences based on previous or current
              site activity, which enables us to provide you with improved
              services. We also use cookies to help us compile aggregate data
              about site traffic and site interaction so that we can offer
              better site experiences and tools in the future.
            </p>
            <p>
              We use cookies to: <br />• Help remember and process the items in
              the shopping cart.
              <br />• Understand and save user's preferences for future visits.
              <br />• Compile aggregate data about site traffic and site
              interactions in order to offer better site experiences and tools
              in the future. We may also use trusted third-party services that
              track this information on our behalf.
            </p>
            <p>
              {"   "}
              You can choose to have your computer warn you each time a cookie
              is being sent, or you can choose to turn off all cookies. You do
              this through your browser settings. Since browser is a little
              different, look at your browser's Help Menu to learn the correct
              way to modify your cookies. If you turn cookies off, some features
              will be disabled. It won't affect the user's experience that make
              your site experience more efficient and may not function properly.
              However, you will still be able to place orders .
            </p>
            <p>
              International Visitors: <br />
              The SmarterHomes website is hosted in the United States and
              Singapore and is intended for Indian and International audiences.
              If you are accessing the site from the European Union or other
              regions with laws governing data collection and use that may
              differ from Indian law, then please note that you are transferring
              your personal data to the SmarterHomes servers hosted in United
              States and Singapore and by providing your personal data you
              consent to that transfer.
            </p>
            <p>
              Third-party disclosure
              <br />
              We do not sell, trade, or otherwise transfer to outside parties
              your Personally Identifiable Information.
            </p>
            <p>
              International Visitors:The Nest website is hosted in the United
              States and is intended for United States and Canadian visitors as
              well as visitors from the United Kingdom, Ireland, France, Belgium
              and the Netherlands. If you are accessing the site from the
              European Union or other regions with laws governing data
              collection and use that may differ from U.S. law, then please note
              that you are transferring your personal data to the United States
              and by providing your personal data you consent to that transfer.
            </p>
            <p>
              {"   "}
              We comply with the US-EU Safe Harbor Framework and the US-Swiss
              Safe Harbor Framework as set forth by the US Department of
              Commerce regarding the collection, use and retention of personal
              information from European Union member countries and Switzerland.
              Nest has certified (through its parent) that it adheres to the
              relevant Safe Harbor Privacy Principles. Third-party links We do
              not include or offer third-party products or services on our
              website.
            </p>
            <p>
              Google
              <br />
              Google's advertising requirements can be summed up by Google's
              Advertising Principles.They are put in place to provide a positive
              experience for users.
              https://support.google.com/adwordspolicy/answer/1316548?hl=en We
              have implemented the following:
              <br />• Demographics and Interests Reporting
            </p>
            <p>
              We, along with third-party vendors such as Google use first-party
              cookies (such as the Google Analytics cookies) and third-party
              cookies (such as the DoubleClick cookie) or other third-party
              identifiers together to compile data regarding user interactions
              with ad impressions and other ad service functions as they relate
              to our website.
            </p>
            <p>Opting out:</p>
            <p>California Online Privacy Protection Act</p>
            <p>
              CalOPPA is the first state law in the nation to require commercial
              websites and online services to post a privacy policy. The law's
              reach stretches well beyond California to require any person or
              company in the United States (and conceivably the world) that
              operates websites collecting Personally Identifiable Information
              from California consumers to post a conspicuous privacy policy on
              its website stating exactly the information being collected and
              those individuals or companies with whom it is being shared. - See
              more at:
              http://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf
            </p>
            <p>
              According to CalOPPA, we agree to the following:
              <br />
              Users can visit our site anonymously.
              <br />
              Once this privacy policy is created, we will add a link to it on
              our home page or as a minimum, on the first significant page after
              entering our website. Our Privacy Policy link includes the word
              'Privacy' and can be easily be found on the page specified above.
            </p>
            <p>
              You will be notified of any Privacy Policy changes: <br />• On our
              Privacy Policy Page Can change your personal information: <br />•
              By emailing us <br />• By logging in to your account <br />• By
              chatting with us or by sending us a support ticket
            </p>
            <p>
              How does our site handle Do Not Track signals?
              <br />
              We honour Do Not Track signals and Do Not Track, plant cookies, or
              use advertising when a Do Not Track (DNT) browser mechanism is in
              place.
            </p>
            <p>
              Does our site allow third-party behavioural tracking? <br />
              It's also important to note that we do not allow third-party
              behavioural tracking
            </p>
            <p>
              COPPA (Children Online Privacy Protection Act) When it comes to
              the collection of personal information from children under the age
              of 13 years old, the Children's Online Privacy Protection Act
              (COPPA) puts parents in control. The Federal Trade Commission,
              United States' consumer protection agency, enforces the COPPA
              Rule, which spells out what operators of websites and online
              services must do to protect children's privacy and safety online.
            </p>
            <p>
              We do not specifically market to children under the age of 13
              years old.
            </p>
            <p>
              Fair Information Practices <br />
              The Fair Information Practices Principles form the backbone of
              privacy law in the United States and the concepts they include
              have played a significant role in the development of data
              protection laws around the globe. Understanding the Fair
              Information Practice Principles and how they should be implemented
              is critical to comply with the various privacy laws that protect
              personal information. In order to be in line with Fair Information
              Practices we will take the following responsive action, should a
              data breach occur:
              <br /> We will notify you via email <br />• Within 1 business day
              We will notify the users via in-site notification <br />• Within 1
              business day
            </p>
            <p>
              We also agree to the Individual Redress Principle which requires
              that individuals have the right to legally pursue enforceable
              rights against data collectors and processors who fail to adhere
              to the law. This principle requires not only that individuals have
              enforceable rights against data users, but also that individuals
              have recourse to courts or government agencies to investigate
              and/or prosecute non-compliance by data processors.
            </p>
            <p>
              CAN SPAM Act
              <br /> The CAN-SPAM Act is a law that sets the rules for
              commercial email, establishes requirements for commercial
              messages, gives recipients the right to have emails stopped from
              being sent to them, and spells out tough penalties for violations.
              We collect your email address in order to:
              <br />• Send information, respond to inquiries, and/or other
              requests or questions <br />• Process orders and to send
              information and updates pertaining to orders. <br />• Send you
              additional information related to your product and/or service{" "}
              <br />• Market to our mailing list or continue to send emails to
              our clients after the original transaction has occurred.
            </p>
            <p>
              To be in accordance with CANSPAM, we agree to the following:{" "}
              <br />• Not use false or misleading subjects or email addresses.{" "}
              <br />• Identify the message as an advertisement in some
              reasonable way. <br />• Include the physical address of our
              business or site headquarters. <br />• Monitor third-party email
              marketing services for compliance, if one is used.
              <br />• Honor opt-out/unsubscribe requests quickly. <br />• Allow
              users to unsubscribe by using the link at the bottom of each
              email.
            </p>
            <p>
              If at any time you would like to unsubscribe from receiving future
              emails, you can email us at <br />• Follow the instructions at the
              bottom of each email. and we will promptly remove you from ALL
              correspondence.
            </p>
            <p>
              Contacting Us <br />
              If there are any questions regarding this privacy policy, you may
              contact us using the information below.
            </p>
            <p>
              SmarterHomes Technologies Private Limited
              <br />
              240A, 2nd Floor, 27th Main, <br />
              Sector 2, HSR Layout,
              <br />
              Bangalore, Karnataka 560102 India
              <br />
              info@smarterhomes.com
              <br /> Ph: +91 80 6673 4646
            </p>
            <p>
              <span style={{ fontStyle: "italic" }}>
                Privacy Policy for the Product:
              </span>{" "}
              <br />
              Updated 28th August 2016 ​
            </p>
            <p>At SmarterHomes, we take your privacy seriously.</p>
            <p>
              This Privacy Statement for SmarterHomes Products and Services
              (“Privacy Statement”) describes information that SmarterHomes
              Technologies and its subsidiaries and affiliates (collectively,
              “SmarterHomes”) collect, use, share, and store, including personal
              information (i.e., information that personally identifies you,
              such as your name, email address or billing information, or other
              data that can be reasonably used to infer this information).
            </p>
            <p>
              This document focuses on information related to the operation of
              SmarterHomes products and services, including the WaterOn™,
              Nuclious™ and other products from SmarterHomes (collectively,
              “SmarterHomes Products”). In this Privacy Statement, the
              expression “SmarterHomes Products” also includes our Web Apps,
              Mobile Apps, and Subscription Services as defined in our Terms of
              Service.
            </p>
            <p>
              We provide additional details about how we collect and use
              information from our public web sites in our Privacy Policy for
              SmarterHomes Web Sites.
            </p>
            <p>
              Our Promise:
              <br />
              •We will be transparent about the different types of information
              we collect and how we use them. <br />
              •We will ask your permission before sharing your personal
              information with third parties for purposes other than at your
              request or to provide SmarterHomes’s Products, and to do so only
              when we think they will provide you with a welcome additional
              service. <br />• We will use best-in-class data security tools to
              keep your data safe and protect the SmarterHomes Products from
              unauthorised access.
            </p>
            <p>
              Your Consent: <br />- Consent to data collection and processing.
              By using SmarterHomes Products, you agree to allow us to collect
              and process information as described in this Privacy Statement.{" "}
              <br />• Consent to data export. Your personal information may be
              collected, processed and stored by SmarterHomes or its service
              providers in India, the United States and other countries where
              our servers reside. Please be aware that the privacy protections
              and legal requirements, including the rights of authorities to
              access your personal information, in some of these countries may
              not be equivalent to those in your country. If you are using
              SmarterHomes Products in the European Union or other regions with
              laws governing data collection and use that may differ from Indian
              law, you consent to the transfer of your personal data to the
              United States and other countries where SmarterHomes operates.
            </p>
            <p>
              What information does the WaterOn meters collect? <br />
              WaterOn collects: <br />• Setup information you provide <br />•
              Water consumption data from the devices <br />• Technical
              information from the device
            </p>
            <p>
              Setup information you provide: When you install the WaterOn,
              you’ll be asked several questions in order to help us create an
              initial configuration of your water metering points. This
              information helps us to map your real time consumption, weekly and
              monthly water report cards to the correct metering point. Water
              Consumption data from the devices: Every time your WaterOn meters
              detect water consumption, they send the data to our servers
              running metering and monitoring application in real time or to its
              nearest time stamp as permitted by communication technology. The
              data is used to generate your water meter bill on behalf of your
              facilities management provider. <br />
              Technical information from the device: In order to improve your
              experience over time and help troubleshoot any problem you may
              encounter with the WaterOn, we record your WaterOn model and
              serial number, software version, and technical information such as
              battery charge level.
            </p>
            <p>
              What information is shared among multiple connected SmarterHomes
              Products? If you have multiple SmarterHomes Products interfacing
              with one another, the products will share certain information with
              each other, such as occupancy data on whether someone is using the
              property. This sharing may occur locally among connected devices
              (both SmarterHomes and third-party devices). Sharing can also
              occur between SmarterHomes Products and your mobile device or
              application, or among SmarterHomes's servers.
            </p>
            <p>
              What additional information does SmarterHomes collect and store
              when a user connects a SmarterHomes Product to the Internet or
              creates an account? Only applicable to WaterOn WOW WiFi model -
              Wi-Fi Network Information: To connect your SmarterHomes Product to
              our Services, or to access your SmarterHomes Product over the
              Internet from a computer, a smartphone or a tablet, you will need
              to connect it to your Wi-Fi network (applicable only for the WiFI
              variant). During setup, the SmarterHomes Product will ask for your
              Wi-Fi network name (SSID) and password to connect to the Internet.
              It will save this information on the device, along with your IP
              address, so that you can access it and control it from your
              computer, smartphone or tablet, and so that it can communicate
              with SmarterHomes servers and download software updates.
            </p>
            <p>
              Once connected to your Wi-Fi network, your SmarterHomes Product
              regularly sends the data described in this Privacy Statement
              (excluding your Wi-Fi password) to SmarterHomes to provide you
              with the Services. Additional authorised Users: SmarterHomes may
              provide you with the ability to enable additional authorised users
              to access your account. If you do so, the additional authorised
              users may control and view all of your devices, content. Invited
              users may also add additional authorised users to your account, so
              be careful to add only those you trust. An invited user must have
              or create a SmarterHomes account, and information about invited
              users (like email address, name, or changes to product settings)
              will be stored with your account.
            </p>
            <p>
              Email Addresses and mobile phone numbers: When you create a
              SmarterHomes account, we collect and store your email address and
              mobile numbers. From that point forward, your email address is
              used for communications from SmarterHomes. In addition,
              SmarterHomes may provide you with the ability to enable
              individuals to access your account as additional authorised users,
              or to invite other individuals such as friends or family to share
              access to your water consumption. We will ask you for the email
              address of any such individuals and automatically send an email
              invitation on your behalf. SmarterHomes stores this information to
              send this email, to register your friend if your invitation is
              accepted, and to track the success of our invitation services.
            </p>
            <p>
              Basic Profile Information: Your account allows you to provide
              certain basic profile information like your name and profile
              photo. Names and profile photos may be shown to others in
              connection with the Services. For example, if you invite someone
              as an additional authorised user, he or she will be able to see
              your name and photo. You should only use photos you are willing to
              make public. Remember that when you visit our Sites, we collect
              personal information as described in our separate Privacy Policy
              for SmarterHomes Web Sites. Like most Internet sites, we routinely
              record log entries (including information such as your IP address)
              and technical information (such as your browser type and version)
              when your browser, mobile device or SmarterHomes Product contacts
              our servers. How does SmarterHomes use the information it
              collects? We use this information to provide, develop and improve
              SmarterHomes Products and services, including to make assessments
              and recommendations about products, safety, or energy use. We may
              use your contact details to send you this information, or to ask
              you to participate in surveys about your SmarterHomes use, and to
              send you other communications from SmarterHomes.
            </p>
            <p>
              We may also use this information in an aggregated, non-identified
              form for research purposes and to help us make sales, marketing,
              and business decisions. For example, we use aggregated user
              information about the number of active meter connections and their
              consumption to use in the case studies and other marketing
              collaterals. We never use any personally identifiable data in any
              such case studies or marketing collaterals.
            </p>
            <p>
              We may use service providers to perform some of these functions.
              Those service providers are restricted from sharing your
              information for any other purpose.
            </p>
            <p>
              We use industry-standard methods to keep this information safe and
              secure while it is transmitted over your home network and through
              the Internet to our servers. Depending on your location and type
              of data, SmarterHomes may process your personal information on
              servers that are not in your home country. In what circumstances
              does SmarterHomes share my information?
            </p>
            <p>
              Under no circumstance do we share personal information for any
              commercial or marketing purpose unrelated to the activation and
              delivery of SmarterHomes Products and services without asking you
              first. Period. We do not rent or sell our customer lists.
            </p>
            <p>
              The following are the limited situations where we may share
              personal information: <br />
              With your explicit consent: We may share personal information when
              we have your consent. One example of this would be if you invite
              another user to access the Products on your account as an
              additional authorised user.
            </p>
            <p>
              For external processing: We have vendors, service providers, and
              technicians who help with some of our processing and storage,
              including helping to answer your questions. They may also assist
              with monitoring our servers for technical problems.
            </p>
            <p>
              These technicians (as well as SmarterHomes employees) can access
              certain information about you or your account in line with this
              work but these technicians are not allowed to use this data for
              non-SmarterHomes purposes. We also have strict policies and
              technical barriers in place to prevent unauthorised employee
              access to video data. <br />
              As part of business transitions: Upon the sale or transfer of the
              company and/or all or part of its assets, your personal
              information may be among the items sold or transferred. We will
              request a purchaser to treat our data under the privacy statement
              in place at the time of its collection.
            </p>
            <p>
              For legal reasons: We may provide information to a third party if
              we believe in good faith that we are required to do so for legal
              reasons. For example, to respond to legal process, or comply with
              state and penal laws (or the applicable laws of foreign countries
              other than the United States). We may share non-personal
              information (for example, aggregated or anonymised customer data)
              publicly and with our partners.
            </p>
            <p>
              Support/ticket related data SmarterHomes will ensure complete
              safety and protection of end user data acquired through various
              support channels and will not share this with any other party
              without the explicit written consent from the customer. In the
              event of such consent, SmarterHomes will be absolved of any
              liability arising due to misuse of personally identifiable
              information.
            </p>
            <p>
              How long does SmarterHomes save my personal information.
              SmarterHomes generally stores your personal information on
              SmarterHomes’s servers until you delete or edit it, or for as long
              as you remain a SmarterHomes customer in order to provide you with
              SmarterHomes Products. As described above, some information is
              processed and stored directly on the SmarterHomes device. All
              personal information is encrypted as it is transmitted to
              SmarterHomes and cannot easily be accessed. Please note that this
              Privacy Statement may change from time to time. We will provide
              notice of any changes on the website or by contacting you.
            </p>
            <p>
              If you have any questions, please contact us at
              info@smarterhomes.com with Privacy in the subject line.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
